import { type SyntheticEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { routes } from '@/common/constants/routes'
import { supabase } from '@/lib/supabase'
import type { UseLoginReturn } from '@/types'

export const useLogin = (): UseLoginReturn => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | undefined>()
  const navigate = useNavigate()

  const handleLogin = async (
    event: SyntheticEvent<HTMLFormElement>,
  ): Promise<void> => {
    event.preventDefault()
    setIsLoading(true)
    setError(undefined)

    const { error: signInError } = await supabase.auth.signInWithPassword({
      email,
      password,
    })

    if (signInError) {
      setError(signInError.message)
      setIsLoading(false)
    } else {
      void navigate(routes.DASHBOARD)
    }
  }

  return {
    email,
    error,
    handleLogin,
    isLoading,
    password,
    setEmail,
    setPassword,
  }
}
